import { Box, Container } from "@mui/material";
import React from "react";
import NewPickup from "../../admin/ReadyForPickup/NewPickup";
import usePageName from "../../../hocs/usePageName";

const NewPickupPage = () => {
  usePageName({
    heading: "New Pickup",
    caption: null,
  });
  return (
    <Container>
      <NewPickup />
    </Container>
  );
};

export default NewPickupPage;
